import { render, staticRenderFns } from "./StudentClassProjection.vue?vue&type=template&id=5af60d9c"
import script from "./StudentClassProjection.vue?vue&type=script&lang=js"
export * from "./StudentClassProjection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports